import {REPORT_ELIGIBLE_FOR_CAB} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_FOR_CAB,
};
